/* ============================= E X P O R T ============================= */

export default {
  name: 'ChevronDown',

  props: {
    color: {
      type: String,
      in: [
        'primary',
        'secundary'
      ]
    }
  }
}
